module.exports = "/_next/static/files/ee8d2b3424aae87e889e6e43704faad5.png";